<template>
  <tab-content-item :active="true">
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">Thêm thành viên</h4>
      </template>
      <template v-slot:body>
        <ValidationObserver v-slot="{ handleSubmit, invalid }">
          <b-form @submit.prevent="handleSubmit(onSubmit)">
            <b-form-group class="row" label-cols-sm="2" label="Tên đăng nhập" label-for="username" label-align-lg="right" label-class="bold">
              <b-row>.
                <b-col>
                  <b-form-input id="username" :placeholder="userInfo.username" disabled="disabled"></b-form-input>
                </b-col>
                <b-col>
                  <v-select plain v-model="user.username_1" :options="options" :clearable="false"/>
                </b-col>
                <b-col>
                  <v-select plain v-model="user.username_2" :options="options" :clearable="false"/>
                </b-col>
              </b-row>
            </b-form-group>
            <b-form-group class="row" label-cols-sm="2" label="Mật khẩu" label-for="password" label-align-lg="right">
              <b-row>
                <b-col>
                  <ValidationProvider rules="required" v-slot="{ errors }" name="password">
                    <b-form-input id="password" type="password" v-model="user.password" placeholder="Mật khẩu"></b-form-input>
                    <span class="text-warning">{{errors[0]}}</span>
                  </ValidationProvider>
                </b-col>
              </b-row>
            </b-form-group>
            <b-form-group class="row" label-cols-sm="2" label="Xác nhận mật khẩu" label-for="password_confirm" label-align-lg="right">
              <b-row>
                <b-col>
                  <ValidationProvider rules="required|confirmed:password" v-slot="{ errors }" name="password_confirm">
                    <b-form-input id="password_confirm" type="password" v-model="user.password_confirm" placeholder="Xác nhận mật khẩu"></b-form-input>
                    <span class="text-warning">{{errors[0]}}</span>
                  </ValidationProvider>
                </b-col>
              </b-row>
            </b-form-group>
            <b-form-group class="row" label-cols-sm="2" label="Họ và tên" label-for="first_name" label-align-lg="right">
              <b-row>
                <b-col lg="8">
                  <ValidationProvider rules="required" v-slot="{ errors }" name="first_name">
                    <b-form-input id="first_name" v-model="user.first_name" placeholder="Họ và chữ lót"></b-form-input>
                    <span class="text-warning">{{errors[0]}}</span>
                  </ValidationProvider>
                </b-col>
                <b-col lg="4">
                  <ValidationProvider rules="required" v-slot="{ errors }" name="last_name">
                    <b-form-input id="last_name" v-model="user.last_name" placeholder="Tên"></b-form-input>
                  </ValidationProvider>
                </b-col>
              </b-row>
            </b-form-group>
            <b-form-group class="row" label-cols-sm="2" label="Số điện thoại" label-for="mobile" label-align-lg="right">
              <b-row>
                <b-col>
                  <ValidationProvider rules="numeric" v-slot="{ errors }" name="mobile">
                  <b-form-input id="mobile" v-model="user.mobile" placeholder="Số điện thoại"></b-form-input>
                    <span class="text-warning">{{errors[0]}}</span>
                  </ValidationProvider>
                </b-col>
              </b-row>
            </b-form-group>
<!--            <b-form-group class="row" label-cols-sm="2" label-for="mobile" label-align-lg="right">-->
<!--              <b-form-checkbox v-model="user.asSub">Vai trò Account sub</b-form-checkbox>-->
<!--            </b-form-group>-->
            <b-form-group class="row" label-cols-sm="2" label-for="mobile" label-align-lg="right">
              <b-button :disabled="invalid || serverRequesting" type="submit" variant="primary" class="mb-3">Thêm thành viên</b-button>
            </b-form-group>
          </b-form>
        </ValidationObserver>
      </template>
    </iq-card>
  </tab-content-item>
</template>
<script>
import { findash } from '../../config/pluginInit'
import { localize } from 'vee-validate'
import { mapGetters } from 'vuex'
import api from '../../store/api'

export default {
  name: 'UserAdd',
  mounted () {
    findash.index()
  },
  created () {
    localize('en', {
      fields: {
        'password': { required: 'Mật khẩu không được để trống' },
        'password_confirm': { required: 'Xác nhận mật khẩu không được để trống', confirmed: 'Mật khẩu xác nhận không chính xác' },
        'first_name': { required: 'Họ không được để trống' },
        'last_name': { required: 'Tên không được để trống' },
        'mobile': { numeric: 'Vui lòng nhập số' }
      }
    })
  },
  data () {
    return {
      options: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      user: {
        username: '',
        username_1: 0,
        username_2: 0,
        password: '',
        password_confirm: '',
        first_name: '',
        last_name: '',
        mobile: '',
        asSub: false
      }
    }
  },
  computed: {
    ...mapGetters({
      'userInfo': 'Auth/userInfoState',
      'serverError': 'Setting/serverErrorsState',
      'serverRequesting': 'Setting/serverRequestingState'
    })
  },
  methods: {
    onSubmit () {
      api.sub_account.create({
        'username_1': this.user.username_1,
        'username_2': this.user.username_2,
        'password': this.user.password,
        'fullname': `${this.user.first_name} ${this.user.last_name}`
      }).then((res) => {
        this.$swal({
          icon: 'success',
          title: 'Thêm tài khoản Sub thành công'
        }).then(() => {
          this.$router.push({ name: 'user-manage.list' })
        })
      }).catch(() => {
        this.$swal({
          icon: 'error',
          title: 'Lỗi...',
          text: this.serverError
        })
      })
    }
  }
}
</script>
